
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsVatRefundDtGrid extends Serenity.EntityGrid<PsVatRefundDtRow, any> {
        protected getColumnsKey() { return PsVatRefundDtColumns.columnsKey; }
        protected getDialogType() { return PsVatRefundDtDialog; }
        protected getIdProperty() { return PsVatRefundDtRow.idProperty; }
        protected getInsertPermission() { return PsVatRefundDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PsVatRefundDtRow.localTextPrefix; }
        protected getService() { return PsVatRefundDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}